import { useEffect, useState } from "react";

import CreatableSelect from "react-select/creatable";
import { Modal } from "bootstrap";

export default function EditModals({ users, tour, additionalCosts, setSelectedAC }) {
  const [selectedUsers, setSelectedUsers] = useState({ value: -1, label: "" });
  const [selectedEscort, setSelectedEscort] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [tourDiscount, setTourDiscount] = useState(0);
  const [price, setPrice] = useState(0);
  const [SAC, setSAC] = useState([]);
  const [AC, setAC] = useState([]);

  function selectBuyer(value) {
    if (value.__isNew__) {
      value = { value: -1, label: value.label };
    }
    setSelectedUsers(value);
  }

  function selectEscorts(value) {
    value = value.map((val) => {
      if (val.__isNew__) {
        return { value: -1, label: val.label };
      }
      return val;
    });
    setSelectedEscort(value);
  }

  useEffect(() => {
    setUserOptions(
      users.map((value) => {
        return {
          value: value.id,
          label: `${value.fname} ${value.lname} - ${value.mobile}`,
        };
      })
    );
  }, [users]);

  useEffect(() => {
    setPrice((tour.price - tourDiscount) * (selectedEscort.length + 1));
  }, [tour.price, tourDiscount, selectedEscort]);

  useEffect(() => {
    setTourDiscount(tour.discount);
    setAC(additionalCosts.map(value => {
      return {
        value: value.id,
        label: value.title
      }
    }))
  }, []);

  return (
    <>
      <div
        class="modal fade text-black"
        id="edit-tour"
        tabindex="-1"
        aria-labelledby="Label"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="Label">
                ویرایش تور
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div className="d-flex align-items-center  my-3">
                <label
                  htmlFor="edit-tour-buyer"
                  style={{ width: "155px" }}
                  className="me-3"
                >
                  نام خریدار :
                </label>
                <CreatableSelect
                  onChange={selectBuyer}
                  options={userOptions.filter((value) => {
                    return (
                      selectedEscort.findIndex(
                        (val) => val.value == value.value
                      ) == -1
                    );
                  })}
                  className="form-control"
                />
              </div>
              <div className="d-flex align-items-center  my-3">
                <label
                  htmlFor="edit-tour-buyer"
                  style={{ width: "155px" }}
                  className="me-3"
                >
                  نام همراهان :
                </label>
                <CreatableSelect
                  isMulti
                  closeMenuOnSelect={false}
                  onChange={selectEscorts}
                  options={userOptions.filter(
                    (value) => selectedUsers.value != value.value
                  )}
                  className="form-control"
                />
                {/* <input
                    type="text"
                    id="edit-tour-buyer"
                    className="form-control"
                    defaultValue="علی احمدی"
                  /> */}
              </div>
              <div className="row">
                <div className="row mb-2">
                  <div className="d-flex align-items-center my-3 col-12 col-md-6 col-lg-4">
                    <label
                      htmlFor="edit-tour-item-price"
                      style={{ width: "215px" }}
                      className="me-3"
                    >
                      قیمت تور :
                    </label>
                    <input
                      type="number"
                      id="edit-tour-item-price"
                      className="form-control"
                      value={tour.price}
                      disabled
                    />
                  </div>
                  <div className="d-flex align-items-center my-3 col-12 col-md-6 col-lg-4">
                    <label
                      htmlFor="edit-tour-total-price"
                      style={{ width: "215px" }}
                      className="me-3"
                    >
                      تخفیف :
                    </label>
                    <input
                      type="number"
                      id="edit-tour-total-price"
                      className="form-control"
                      min={0}
                      max={tour.price}
                      value={tourDiscount}
                      onChange={(e) => setTourDiscount(e.target.value)}
                    />
                  </div>
                  <div className="d-flex align-items-center my-3 col-12 col-md-6 col-lg-4">
                    <label
                      htmlFor="edit-tour-total-price"
                      style={{ width: "215px" }}
                      className="me-3"
                    >
                      تعداد :
                    </label>
                    <input
                      type="number"
                      id="edit-tour-total-price"
                      className="form-control"
                      disabled
                      value={selectedEscort.length}
                    />
                  </div>
                </div>
                <div className="d-flex justify-content-end">
                  <div className="d-flex align-items-center my-3 col-12 col-md-6 col-lg-4">
                    <label
                      htmlFor="edit-tour-total-price"
                      style={{ width: "215px" }}
                      className="me-3"
                    >
                      جمع کل:
                    </label>
                    <input
                      type="number"
                      id="edit-tour-total-price"
                      className="form-control"
                      disabled
                      value={price}
                    />
                  </div>
                </div>
              </div>
              <hr style={{ lineHeight: 3 }} />
              {/* هزینه های اضافی */}
              <div className="text-center">
                <div className="fw-bold">هزینه های اضافی</div>
              </div>

              <div
                className={`the-additional-cost d-flex flex-wrap additional-cost`}
              >
                <div>
                  <div className="title">عنوان تور</div>
                  <div className="description">
                <label
                    htmlFor="edit-tour-transfer"
                    style={{ width: "215px" }}
                    className="me-3"
                  >
                    ترنسفر تا مبدا حرکت
                  </label></div>
                </div>
                <div>
                  <div className="title">
                    قیمت واحد
                  </div>
                  <input
                    type="number"
                    id="edit-tour-transfer"
                    className="form-control"
                    disabled
                    // value={}
                  />
                </div>
              </div>
              <div className="d-flex justify-content-end">
                <div
                  htmlFor="edit-tour-transfer"
                  style={{ width: "215px" }}
                  className="me-3"
                >
                 جمع کل :
                </div>
                <div
                > {} </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                انصراف
              </button>
              <button type="button" class="btn btn-primary">
                ثبت ویرایش
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
